import { useState, useRef, useEffect } from "react";
import { useCurrency } from "@/context/CurrencyContext";
import { Globe, Check } from "lucide-react";

const LABELS = {
  INR: "Indian Rupee",
  USD: "US Dollar",
  GBP: "British Pound",
  EUR: "Euro",
  AED: "UAE Dirham",
  SGD: "Singapore Dollar",
};

export default function CurrencySelector({ compact = false }) {
  const { currency, setCurrency, supported, symbols } = useCurrency();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        data-testid="currency-toggle"
        onClick={() => setOpen((v) => !v)}
        className={`${compact ? "h-10 px-3" : "h-10 px-3.5"} rounded-full flex items-center gap-1.5 glass text-xs font-semibold text-blue-950 dark:text-white`}
        aria-label="Select currency"
      >
        <Globe className="w-3.5 h-3.5 text-[#D4AF37]"/>
        {currency}
      </button>
      {open && (
        <div data-testid="currency-menu" className="absolute right-0 top-12 w-56 rounded-2xl glass p-2 shadow-2xl z-50">
          <div className="px-3 py-2 text-[10px] uppercase tracking-widest text-slate-500">Currency</div>
          {supported.map((c) => (
            <button
              key={c}
              data-testid={`currency-${c}`}
              onClick={() => { setCurrency(c); setOpen(false); }}
              className="w-full flex items-center justify-between px-3 py-2 rounded-xl hover:bg-[#D4AF37]/10 text-sm"
            >
              <span className="flex items-center gap-2">
                <span className="font-bold w-8 text-[#D4AF37]">{c}</span>
                <span className="text-slate-600 dark:text-slate-300">{LABELS[c]}</span>
              </span>
              {currency === c && <Check className="w-4 h-4 text-[#D4AF37]"/>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
